import { api } from "@/lib/api";
import { type Schemas } from "@/types";
import { useQuery } from "react-query";

export default function AppointmentListQuery() {
  const { data } = useQuery({
    queryKey: ["appointmentListStats"],
    queryFn: async () => {
      const response = await api.get<Schemas["AppointmentListStats"]>(
        "/api/Reports/AppointmentListStats",
      );
      return response.data;
    },
  });

  return {
    appointments: data?.appointments ?? [],
  };
}
